const observer = new MutationObserver(function(mutationList, observer) {
  
      const checkbox_main = document.getElementById("addmemberprd");
      const variantId = 46470092226778;
      const sellingPlanId = 26171244762;   


    console.log("me em mem");
  
     //for (const mutation of mutationList) {

        // ✅ 1. On page load — check if item is already in cart
        fetch('/cart.js')
          .then(response => response.json())
          .then(cart => {
            const freeshippItem = cart.items.find(item => item.product_id === 8585895248090);
            console.log(cart.items);
            if (freeshippItem){
        const itemExists = cart.items.some(item => item.variant_id === variantId);
        //const shippingField = document.querySelector(".shipping__rate--inner");
        
        if (itemExists && checkbox_main) {
            checkbox_main.checked = true;
            if (shippingField) {
                shippingField.innerText = "FREE";
            }
        } else if(freeshippItem){
          
            const variantTitle = freeshippItem.variant_title.toLowerCase(); // Normalize
        
            let shippingValue = 0;
        
            if (variantTitle.includes("50 core")) {
                shippingValue = 16.75;
            } else if (variantTitle.includes("100 core")) {
                shippingValue = 7.31;
            } else if (variantTitle.includes("6 core")) {
                shippingValue = 4.93;
            } else if (variantTitle.includes("12 core")) {
                shippingValue = 7.31;
            } else if (variantTitle.includes("24 core")) {
                shippingValue = 8.79;
            }else{
               shippingValue = "no";
            }
        
            shippingField.innerText = "$" + shippingValue;
        }
            else{
             shippingField.innerText ="Calculated At checkout"
            }
        
            }
            else{
             var checkbm= document.querySelector(".become_a-memberwidget");
              checkbm.style.display="none";
            }
          })
          .catch(error => {
            console.error('Error checking cart on load:', error);
          });
        
        // ✅ 2. Handle checkbox change (add/remove item)
        if (checkbox_main) {
          checkbox_main.addEventListener("change", function () {
            if (checkbox_main.checked) {
              // Check again to prevent duplicate add
              fetch('/cart.js')
                .then(response => response.json())
                .then(cart => {
                  const itemExists = cart.items.some(item => item.variant_id === variantId);
        
                  if (!itemExists) {
                    // Add item
                    const formData = {
                      items: [{
                        id: variantId,
                        quantity: 1,
                        selling_plan: sellingPlanId
                      }]
                    };
        
                    fetch(window.Shopify.routes.root + 'cart/add.js', {
                      method: 'POST',
                      headers: {
                        'Content-Type': 'application/json'
                      },
                      body: JSON.stringify(formData)
                    })
                      .then(response => response.json())
                      .then(data => {
                        checkbox_main.checked = true;                       
                      })
                      .catch(error => {
                        console.error('Error adding item:', error);
                      });
                  } else {
                    checkbox_main.checked = true;
                    console.log('Item already in cart.');
                  }
                })
                .catch(error => {
                  console.error('Error checking cart before add:', error);
                });
        
            } else {
              // Remove item
              fetch('/cart.js')
                .then(response => response.json())
                .then(cart => {
                  let lineToRemove = null;
        
                  for (let i = 0; i < cart.items.length; i++) {
                    if (cart.items[i].variant_id === variantId) {
                      lineToRemove = i + 1;
                      break;
                    }
                  }
        
                  if (lineToRemove !== null) {
                    checkbox_main.checked = false;
                  } else {
                    checkbox_main.checked = false;
                  }
                })
                .catch(error => {
                  console.error('Error removing item:', error);
                });
            }
          });
        }
       
       
     //}
});

// Select the element you want to watch
const elementNode = document.querySelector('.cart-drawer');

// Call the observe function by passing the node you want to watch with configuration options
observer.observe(elementNode, { 
    attributes: true, 
    childList: true, 
    subtree: true }
);